/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export const getRoomAndAnchor = createAsyncThunk(
  'WelcomeTasks/getRoomAndAnchor',
  async (p: any, store: any) => {
    const resp = await http.post('/live/misc/wnp_room_and_anchor', {
      ...store.getState().env.deviceinfo,
      ...p,
      anchor_id: store.getState().env.deviceinfo.h_m,
    })
    return resp.data
  }
)

export const getRankTimes = createAsyncThunk(
  'WelcomeTasks/getRankTimes',
  async (p, store: any) => {
    const resp = await http.post('/live/misc/wnp_rank_times', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)
export enum task_type_enum {
  房间任务 = 0,
  主播任务 = 1,
  金币任务 = 2,
}
interface ITask {
  task_id: number
  task_type2: task_type_enum
  desc: string
  value: number // 积分值
  limit: number
  have: number
  show_limit: boolean
}

const initialState: {
  room_task_info: Array<ITask>
  anchor_task_info: Array<ITask>
  list?: {
    name: string
    list: ITask[]
  }[]
  day_value: number
  week_value: number
  time_list: Array<Array<string>>
  isEmptyAnchorRank: boolean
  isEmptyUnionRank: boolean
} = {
  room_task_info: [
    // {
    //   desc: 'User follows room',
    //   value: 5,
    //   have: 3,
    //   limit: 10,
    // },
    // {
    //   desc: 'Stay over 2 miniutes',
    //   value: 15,
    //   have: 6,
    //   limit: 15,
    // },
    // {
    //   desc: 'Chat over 600 seconds',
    //   value: 3,
    //   have: 29,
    //   limit: 30,
    // },
  ],
  anchor_task_info: [],
  day_value: 0,
  week_value: 0,
  time_list: [
    // ['2022.03.20', '2022.03.26'],
  ],
  isEmptyAnchorRank: false,
  isEmptyUnionRank: false,
}
export const WelcomeTasksSlice = createSlice({
  name: 'WelcomeTasks',
  initialState,
  reducers: {
    setIsEmptyAnchorRank(state, action) {
      state.isEmptyAnchorRank = action.payload
    },
    setIsEmptyUnionRank(state, action) {
      state.isEmptyUnionRank = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRoomAndAnchor.fulfilled, (state, action) => {
        const {data = {}} = action.payload
        Object.assign(state, data)
      })
      .addCase(getRankTimes.fulfilled, (state, action) => {
        const {data = {}} = action.payload
        Object.assign(state, data)
      })
  },
})

export default WelcomeTasksSlice.reducer
export const {setIsEmptyAnchorRank, setIsEmptyUnionRank} =
  WelcomeTasksSlice.actions
